module.exports = __webpack_public_path__ + "static/media/label-9.4a5fd275.svg";